/* istanbul ignore file */
import styled, { css } from 'styled-components';

import { media } from 'app/shared/styles_js/variables';
import { getWidth } from 'app/marketplace/contentful/utils';
import { BreadcrumbContainerSt } from 'app/marketplace/search/Breadcrumb/Breadcrumb.css';

export const VariantSt = styled.div`
  color: ${({ theme: { colors } }) => colors.tarmacGrey};
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: auto;
  padding-top: 74px;
  padding-bottom: 80px;
  ${media.lg(css`
    ${getWidth('lg')}
    padding-top: 78px;
  `)}
  ${media.xl(css`
    ${getWidth('xl')}
  `)}
  ${BreadcrumbContainerSt} {
    display: block;
  }
`;
